import { prefix } from "@/utils/str";
import authorize from "../utils/authorize";

export const routeName = (name, parent = "") => {
  return !parent ? name : prefix(parent, name, ".");
};

export const allMenu = (menu) => {
  let data = [];

  menu.forEach((item) => {
    data.push(item);

    if (item.children) {
      data = data.concat(allMenu(item.children));
    }
  });
  return data;
};
/**
 * 整理路由
 *
 * 本地定義的menu路由與API回傳的menu合併
 *  本地路由，僅針對component作定義
 *  遠端menu，所有定義皆視同route.meta的元訊息
 *
 * @param {array} routes 路由集合
 * @param {array} menu 側邊選單集合
 */
export const mergeMenu = (routes, menu, i18n, parent = null) => {
  let map = [];
  // routes = JSON.parse(JSON.stringify(routes));
  routes.forEach((route) => {
    // 本地首頁直接從children開始
    if (route.name === "home") {
      route.children = mergeMenu(route.children, menu, i18n, route);
      map.push(route);
      return;
    }

    let m = menu.filter((m) => m.name == route.name);

    if (m.length > 1) {
      throw "路由名稱不能重複";
    }

    m = { ...m[0] };

    if (m && m.title) {
      let langKey = "menu." + m.name;

      if (m.children) {
        langKey += ".title";
      }

      m.title = i18n.te(langKey) ? i18n.t(langKey) : m.title;
      m.langKey = langKey;
    }

    if (m.props) {
      route.params = { ...route.params, ...m.props };
    }

    // merge meta info
    route.meta = { ...route.meta, ...m };
    delete route.meta["name"];
    delete route.meta["children"];

    if (route.children) {
      route.children = mergeMenu(route.children, menu, i18n, route);
    }

    if (parent) {
      route.meta.parent = {
        name: parent.name,
        title: parent.meta ? parent.meta.title : "",
      };
    }

    map.push(route);
  });

  return map;
};

/**
 * 驗證路由
 */
export const validateRoutes = (routes, user) => {
  let map = [];

  routes.forEach((route) => {
    // 創建路由的深拷貝，避免直接修改原始對象
    const routeCopy = { ...route };

    if (routeCopy.children) {
      routeCopy.children = validateRoutes(routeCopy.children, user);
    }

    if (routeCopy.meta) {
      // 驗證權限
      if (authorize.pass(user, routeCopy.meta.permissions)) {
        map.push(routeCopy);
      }
    } else {
      map.push(routeCopy);
    }
  });

  return map;
};
